var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st1{fill:#FFFFFF;}\n"),React.createElement("g",{"key":1},[React.createElement("circle",{"cx":"9","cy":"9","r":"8","fill":"transparent","key":0}),React.createElement("path",{"className":"st1","d":"M15.4,2.6c-3.5-3.5-9.2-3.5-12.7,0s-3.5,9.2,0,12.7c3.5,3.5,9.2,3.5,12.7,0C18.9,11.8,18.9,6.2,15.4,2.6z\n\t\t M13.2,10H10v3.2c0,0.6-0.4,1-1,1s-1-0.4-1-1V10H4.8c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1H8V4.8c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1V8\n\t\th3.2c0.6,0,1,0.4,1,1C14.2,9.6,13.8,10,13.2,10z","key":1})])]);
}

Plus.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 18 18","style":{"enableBackground":"new 0 0 18 18"},"xmlSpace":"preserve"};

module.exports = Plus;

Plus.default = Plus;
